<div *adaptLoading="!culturalActivityConfiguration"
     class="form-group">
    <label for="catchupFrequency">{{ title }} <small>(in months)</small></label>

    <div>
        <small class="text-muted">Setting this to <b>0</b> will disable automatic catch-up
            scheduling{{ cancelsFutureCatchups ? " and will cancel any future catch-ups" : "" }}.</small>
    </div>

    <ng-content></ng-content>

    <div class="d-flex align-items-center gap-2 mt-2">
        <dx-number-box id="catchupFrequency"
                       [adaptValidateEntity]="culturalActivityConfiguration"
                       adaptValidateEntityProperty="frequencyMonths"
                       [value]="culturalActivityConfiguration!.frequencyMonths"
                       (onValueChanged)="onValueChanged($event)"
                       [showSpinButtons]="true"
                       [min]="0"
                       [max]="12"
                       width="200px"
                       data-test="catchup-frequency-months"></dx-number-box>
        @if (!!teamId && !culturalActivityConfiguration?.teamId) {
            <span class="fal fa-info-circle"
                  adaptTooltip="This is the organisation default."></span>
        }
    </div>

    @if (!!teamId) {
        <button adaptButtonIcon="fal fa-fw fa-sync"
                class="btn btn-link mt-2"
                [disabled]="!culturalActivityConfiguration?.teamId"
                [adaptBlockingClick]="resetToOrganisationDefault">Reset to organisation default</button>
    }
</div>
